import CityPageTemplate from "../city-template/CityPageTemplate";
import { blacksburgVaConfig } from "./data";

export default function BlacksburgVaPage() {
  return <CityPageTemplate config={blacksburgVaConfig} />;
}